import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class U2000_SecurityService {
    constructor() {}
}
